import { CountryInput } from '@paypalcorp/pp-react-country-input'
import { navigate } from 'gatsby'
import React, { useState, useEffect, useLayoutEffect } from 'react'
import { useApplicationContext } from '../../../provider'
import countrySelectorOptions from './countryList.yaml'
import _ from 'lodash'
import { payLaterAvailability } from './countryMapping'
import { removeGAParam } from '../../pp-react-wrappers'

export default function CountryDropdown(props) {
  const [performRedirect, setPerformRedirect] = useState(false)
  const { countrySelection, updateCountrySelection } = useApplicationContext()
  const countryCodeRegex = /\/[A-Z0-9]{2}\//i

  const onFormChange = (event) => {
    let newCountry = event.target.value
    if (newCountry !== countrySelection) {
      // country drop down is currently shown only to pay later so we are firing
      // BNPL amplitude tags
      // camelCase is not allowed in FPTI Tags so using snake_case instead for prop names
      // we need to enhance event_props to support comma separated value later on
      const data = {
        product: 'pay_later_merchant',
        event_name: 'pay_later_country_filter_clicked',
        event_props: 'pay_later_country_selected,life_cycle_product',
        pay_later_country_filter_name: newCountry,
        life_cycle_product: 'developer_docs',
      }

      if (typeof window !== `undefined` && window.fpti) {
        data.page_name = window.fpti.page.replace(/:/g, '_')
        data.pu = removeGAParam(window.location.href)
      }
      // eslint-disable-next-line mdx/no-unused-expressions
      // eslint-disable-next-line no-unused-expressions
      window?.PAYPAL?.analytics?.instance?.recordClick({
        data,
      })

      updateCountrySelection(newCountry)
      setPerformRedirect(true)
    }
  }

  const stripSlashes = (value) => {
    return value.replaceAll('/', '')
  }

  const getAvailableCountries = () => {
    const generalPath =
      typeof window !== 'undefined' &&
      window.location.pathname.replace(countryCodeRegex, '/')
    const filteredCountries = payLaterAvailability[generalPath]

    if (!filteredCountries) {
      return countrySelectorOptions
    }

    return filteredCountries.map((country) =>
      countrySelectorOptions.find(
        (countryOption) => countryOption.countryCode === country,
      ),
    )
  }

  const availableCountries = getAvailableCountries()

  const setSelection = () => {
    let countryName = availableCountries.find(
      (country) => country.countryCode === countrySelection,
    )
    let selectionIndex = countryName ? countryName.label : 'United States'
    let urlCountry =
      typeof window !== `undefined` &&
      window.location.pathname.match(countryCodeRegex)
    if (urlCountry) {
      let newCountryCode = stripSlashes(urlCountry[0]).toUpperCase()
      updateCountrySelection(newCountryCode)
      countryName = availableCountries.find(
        (country) => country.countryCode === newCountryCode,
      )
      selectionIndex = countryName ? countryName.label : 'United States'
    }

    return selectionIndex
  }

  useLayoutEffect(() => {
    let countrydropdown = document.getElementsByClassName('countryDropdown')[0]
    const value = Math.max(
      ...availableCountries.map((country) => country.label.length),
    )
    countrydropdown.style.width = value < 18 ? '18ch' : `${value + 2}ch`
  }, [])

  useEffect(() => {
    if (performRedirect) {
      setPerformRedirect(false)
      let newUrl =
        typeof window !== `undefined` &&
        window.location.pathname.replace(
          countryCodeRegex,
          `/${countrySelection.toLowerCase()}/`,
        )
      navigate(newUrl)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countrySelection])

  return (
    <div className="countryDropdown">
      <CountryInput
        countryList={availableCountries}
        name="countryDropdown"
        value={setSelection()}
        onChange={onFormChange}
      />
    </div>
  )
}
